declare const window: any;
import MessageBus from 'q2-tecton-common/lib/utility/message-bus';
import { Maybe } from 'maybe-not';
import { ISources } from 'src/types';

export function createGlobalScripts(scripts: string[]) {
    if (Array.isArray(scripts)) {
        scripts.forEach(script => {
            const newScript = document.createElement('script');
            newScript.async = true;
            newScript.src = script;
            document.querySelector('head')!.appendChild(newScript);
        });
    }
}

export function setupGlobalScripts(
    messageBus: MessageBus,
    capabilities: Set<string>,
    sources: ISources
): Promise<string[]> {
    if (capabilities.has('getGlobalScripts')) {
        return messageBus
            .sendRequest<Promise<string[]>>('getGlobalScripts', Maybe.nothing())
            .then(response => {
                return response.value;
            });
    } else if (window.Tecton?.UUX_VERSION && sources.fetchPlatformData) {
        return sources.fetchPlatformData('q2Config').then(result => {
            return result.response.tecton?.globalScripts || [];
        });
    } else {
        return Promise.reject();
    }
}
